import { render, staticRenderFns } from "./TrxClient.vue?vue&type=template&id=11c1150c"
import script from "./TrxClient.vue?vue&type=script&lang=js"
export * from "./TrxClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports